import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData'
import useAct from '../useAct'

export default function LanguageSelector() {
  const act = useAct()
  const selectedLanguage = useSel(s => s.local.language || 'en')

  const handleLanguageChange = (event) => {
    act.local.setLanguage(event.target.value);
  }

  const clientLanguages = clientLanguagesData()
  
  if (Object.keys(clientLanguages).length <= 1) {
    return <></>
  }

  return (
    <select value={selectedLanguage} onChange={handleLanguageChange}>
      { Object.entries(clientLanguages).map(([lang, data]) => (
        <option key={lang} value={lang}>
          {data.flag} {data.name}
        </option>
      )) }
    </select>
  )
}
